export interface PointRewards {
  totalPointReward: RewardPointAmount
  rewards: RewardRule[]
}

export interface RewardRule {
  type: RewardType
  rewardDetails: {
    description: string
    priceRange: {
      minAmountInclusive: number | null
      maxAmountExclusive: number | null
    } | null
    point: RewardPointAmount
  }[]
}

export enum RewardType {
  REVIEW = 'REVIEW',
  PAYMENT = 'PAYMENT',
  RESERVATION = 'RESERVATION',
}

export interface RewardPointAmount {
  paybackPercentage: number | null
  amount: number | null
}
